import type { TourConfig } from '../../types/tour.types'

// Subscription / billing. The current-plan card uses the stable `.plan-card` class; the actions
// card has a `data-tour` anchor (added alongside this tour) and is only shown to users who can
// manage the subscription, so that step is optional.
const subscriptionTour: TourConfig = {
  id: 'subscription',
  title: 'Manage your plan',
  module: 'Account',
  routeName: 'Subscription',
  order: 12,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Your plan and billing in one place',
      body: 'This is where you see your current plan, track your remaining credits, switch plans, update your payment method and grab invoices — no need to contact support.',
    },
    {
      id: 'plan',
      target: '.plan-card',
      placement: 'bottom',
      title: 'Your plan at a glance',
      body: 'Here\'s your **current plan and status**, plus the **export and mobile credits** you have left — so you always know how much prospecting you can do before you run out.',
    },
    {
      id: 'actions',
      target: '[data-tour="sub-actions"]',
      placement: 'top',
      // Only shown to users who can manage the subscription.
      optional: true,
      title: 'Change plan, pay and invoices',
      body: 'Manage everything from here: **change your plan**, **update your payment method**, **view invoices** or **cancel**. You review any plan change before anything is charged.',
    },
  ],
}

export default subscriptionTour
